import Button from "ds/components/Button";

import useLaunchPadLearnResumeActiveMission from "../useResumeActiveMission";

const LaunchPadLearnContinueMissionButton = () => {
  const { activeMission, handleContinue } = useLaunchPadLearnResumeActiveMission();

  if (!activeMission) return null;

  return (
    <Button variant="primary" onPress={handleContinue}>
      Continue mission
    </Button>
  );
};

export default LaunchPadLearnContinueMissionButton;
